import React, { useEffect, useRef, useState } from "react";
import { API_URL } from "../../../constants/appConfig";
import myToast from "../../../components/toast";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  MenuItem,
  CircularProgress,
  Divider,
  Alert,
  Grid,
} from "@mui/material";
import { AddPhotoAlternate as AddPhotoIcon } from "@mui/icons-material";
import heic2any from "heic2any";

const Index = ({ fetchedProduct }) => {
  const [savingProduct, setSavingProduct] = useState(false);
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(fetchedProduct);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [productCategory, setProductCategory] = useState({});
  const [productSubcategory, setProductSubcategory] = useState({});
  const [productCarat, setProductCarat] = useState({});
  const [carats, setCarats] = useState([]);
  const [productImage, setProductImage] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const navigate = useNavigate();

  const fileInputRef = useRef(null);
  const triggerFileInput = () => {
    fileInputRef.current.click(); // Butona tıklandığında dosya seçme inputunu tetikletiyoruz
  };
  useEffect(() => {
    setLoading(true);
    getAllCategory();
    getAllCarat();
    if (fetchedProduct) {
      setProduct(fetchedProduct);
      setProductImage(fetchedProduct.imageBase64Data);
      if (fetchedProduct.productCaratFk) {
        setProductCarat(fetchedProduct.productCaratFk.caratId);
      }
      if (fetchedProduct.productCategoryFk) {
        handleSelectCategory(fetchedProduct.productCategoryFk.categoryId);
        if (fetchedProduct.productSubCategoryFk) {
          handleSelectSubCategory(
            fetchedProduct.productSubCategoryFk.subcategoryId
          );
        }
      }
    }
    setLoading(false);
  }, []);
  const getAllCarat = async () => {
    try {
      const API = API_URL + "/carat/getAllCarat";
      const response = await fetch(API);
      const data = await response.json();
      setCarats(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getAllCategory = async () => {
    try {
      const API =
        API_URL + "/category/getAllCategoryByCurrency" + "?currency=true";
      const response = await fetch(API);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSelectCategory = (selectedCategory) => {
    const API =
      API_URL +
      "/subCategory/getSubCategoryByCategoryId" +
      "?categoryId=" +
      selectedCategory;
    fetch(API)
      .then((response) => response.json())
      .then((data) => {
        setSubCategories(data);
      });
    setProductCategory(selectedCategory);
    setProductSubcategory(null);
  };
  const handleSelectSubCategory = (selectedSubCategory) => {
    setProductSubcategory(selectedSubCategory);
  };

  const saveProduct = async (data) => {
    try {
      const API = API_URL + "/product/saveProduct";
      var productData = {};
      if (productImage === null && data.productImage) {
        productData = {
          ...data,
          productCategoryFk: { categoryId: productCategory },
          productSubCategoryFk: productSubcategory
            ? { subcategoryId: productSubcategory }
            : null,
          productCaratFk: { caratId: productCarat },
        };
      } else if (productImage !== null && data.productImage) {
        productData = {
          ...data,
          imageBase64Data: productImage,
          productCategoryFk: { categoryId: productCategory },
          productSubCategoryFk: productSubcategory
            ? { subcategoryId: productSubcategory }
            : null,
          productCaratFk: { caratId: productCarat },
        };
      } else {
        productData = {
          ...data,
          imageBase64Data: productImage,
          productCategoryFk: { categoryId: productCategory },
          productSubCategoryFk: productSubcategory
            ? { subcategoryId: productSubcategory }
            : null,
          productCaratFk: { caratId: productCarat },
        };
      }

      const response = await fetch(API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(productData),
      });
      const result = await response.json();
      return result;
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSaveProduct = async () => {
    if (!product.productName) {
      myToast({ status: "warn", message: "Ürün adı boş olamaz" });
      return;
    } else if (!product.productGainMilyem) {
      myToast({ status: "warn", message: "Kazanç milyemi boş olamaz" });
      return;
    } else if (!product.productGram) {
      myToast({ status: "warn", message: "Gram boş olamaz" });
      return;
    } else {
      setSavingProduct(true);

      try {
        const response = await saveProduct(product);
        if (response?.productId) {
          myToast({ status: "success", message: "Ürün başarıyla güncellendi" });
          navigate("/products");
          // window.location.href = "/products";
        } else {
          myToast({
            status: "error",
            message: "Ürün güncellenirken hata oluştu",
          });
        }
      } catch (error) {
        myToast({ status: "error", message: "Ürün eklenirken hata oluştu" });
      }
      setSavingProduct(false);
    }
  };

  const handleFileUpload = async (event) => {
    try {
      setImageLoading(true);
      let file = event.target.files[0];
      const aspectRatio = 3 / 4;

      // HEIC formatını kontrol et ve dönüştür
      if (file.type === "image/heic" || file.name.toLowerCase().endsWith('.heic')) {
        try {
          const jpegBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8
          });
          file = new File([jpegBlob], file.name.replace('.heic', '.jpg'), {
            type: "image/jpeg"
          });
        } catch (error) {
          setImageLoading(false);
          myToast({ 
            status: "error", 
            message: "HEIC formatı dönüştürülürken hata oluştu" 
          });
          return;
        }
      }

      // Desteklenen formatları kontrol et
      if (!file.type.startsWith('image/')) {
        setImageLoading(false);
        myToast({ 
          status: "error", 
          message: "Lütfen geçerli bir resim dosyası seçin (JPEG, PNG, HEIC)" 
        });
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        const image = new Image();
        image.src = reader.result;

        image.onload = () => {
          const width = image.width;
          const height = image.height;
          const calculatedAspectRatio = width / height;

          if (calculatedAspectRatio !== aspectRatio) {
            setImageLoading(false);
            myToast({
              status: "warn",
              message: "Resmin boyutları 3/4 boyutunda olmalıdır örn: 750*1000",
            });
          } else {
            // Resim sıkıştırma işlemi
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            
            const maxWidth = 750;
            const maxHeight = 1000;
            
            canvas.width = maxWidth;
            canvas.height = maxHeight;

            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(image, 0, 0, maxWidth, maxHeight);

            const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8);
            setProductImage(compressedBase64);
            setImageLoading(false);
          }
        };
      };
    } catch (error) {
      console.error(error);
      setImageLoading(false);
      myToast({ status: "error", message: "Resim yüklenirken hata oluştu" });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Grid container spacing={4}>
          {/* Sol Taraf - Resim Alanı */}
          <Grid item xs={12} md={4}>
            <Box sx={{ position: 'relative' }}>
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  paddingTop: '133.33%', // 3:4 aspect ratio
                  borderRadius: 2,
                  overflow: 'hidden',
                  boxShadow: 3,
                  bgcolor: 'grey.100'
                }}
              >
                {imageLoading ? (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'rgba(255, 255, 255, 0.8)',
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <Box
                    component="img"
                    src={productImage || API_URL + "/" + fetchedProduct?.productImage || "https://placehold.co/750x1000"}
                    alt="Ürün Görseli"
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                )}
              </Box>

              <input
                type="file"
                accept="image/jpeg, image/png, image/jpg, image/heic"
                ref={fileInputRef}
                onChange={handleFileUpload}
                hidden
              />

              <Button
                fullWidth
                variant="contained"
                startIcon={<AddPhotoIcon />}
                onClick={triggerFileInput}
                sx={{
                  mt: 2,
                  bgcolor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    bgcolor: 'primary.dark',
                  }
                }}
              >
                Resim Değiştir
              </Button>

              <Alert severity="info" sx={{ mt: 2 }}>
                Resim boyutu 750x1000 px (3:4 oran) olmalıdır
              </Alert>
            </Box>
          </Grid>

          {/* Sağ Taraf - Form Alanı */}
          <Grid item xs={12} md={8}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              <Typography variant="h5" color="primary.main" gutterBottom>
                {fetchedProduct ? 'Ürün Düzenle' : 'Yeni Ürün Ekle'}
              </Typography>

              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <Alert severity="info" sx={{ mb: 2 }}>
                    Ürün başlığı 20 karakterden uzun olmamalıdır
                  </Alert>

                  {/* Form alanları */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                    <TextField
                      fullWidth
                      label="Ürün Adı"
                      value={product.productName || ''}
                      onChange={(e) => {
                        if (e.target.value.length <= 20) {
                          setProduct({
                            ...product,
                            productName: e.target.value,
                          });
                        }
                      }}
                      size="small"
                    />

                    <TextField
                      fullWidth
                      label="Ürün Açıklaması"
                      value={product.productDescription || ''}
                      onChange={(e) =>
                        setProduct({
                          ...product,
                          productDescription: e.target.value,
                        })
                      }
                      multiline
                      rows={3}
                      size="small"
                    />

                    <TextField
                      fullWidth
                      type="number"
                      label="Kazanç Milyemi"
                      value={product.productGainMilyem || ''}
                      onChange={(e) =>
                        setProduct({
                          ...product,
                          productGainMilyem: e.target.value,
                        })
                      }
                      size="small"
                    />

                    <TextField
                      fullWidth
                      type="number"
                      label="Gram"
                      value={product.productGram || ''}
                      onChange={(e) =>
                        setProduct({
                          ...product,
                          productGram: e.target.value,
                        })
                      }
                      size="small"
                    />

                    <TextField
                      select
                      fullWidth
                      label="Ayar"
                      value={productCarat || ''}
                      onChange={(e) => setProductCarat(e.target.value)}
                      size="small"
                    >
                      {carats.map((carat) => (
                        <MenuItem key={carat.caratId} value={carat.caratId}>
                          {carat.caratName}
                        </MenuItem>
                      ))}
                    </TextField>

                    <TextField
                      select
                      fullWidth
                      label="Kategori"
                      value={productCategory || ''}
                      onChange={(e) => handleSelectCategory(e.target.value)}
                      size="small"
                    >
                      {categories.map((category) => (
                        <MenuItem key={category.categoryId} value={category.categoryId}>
                          {category.categoryName}
                        </MenuItem>
                      ))}
                    </TextField>

                    {subCategories.length > 0 && (
                      <TextField
                        select
                        fullWidth
                        label="Alt Kategori"
                        value={productSubcategory || ''}
                        onChange={(e) => handleSelectSubCategory(e.target.value)}
                        size="small"
                      >
                        {subCategories.map((subCategory) => (
                          <MenuItem
                            key={subCategory.subcategoryId}
                            value={subCategory.subcategoryId}
                          >
                            {subCategory.subcategoryName}
                          </MenuItem>
                        ))}
                      </TextField>
                    )}

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={product.productVisible || false}
                          onChange={() =>
                            setProduct({
                              ...product,
                              productVisible: !product.productVisible,
                            })
                          }
                          color="primary"
                        />
                      }
                      label="Görünür"
                    />
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  {/* Butonlar */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button 
                      variant="outlined" 
                      color="error"
                      onClick={() => navigate('/products')}
                    >
                      İptal
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleSaveProduct}
                      disabled={savingProduct}
                      startIcon={savingProduct && <CircularProgress size={20} />}
                    >
                      {savingProduct ? 'Kaydediliyor...' : 'Kaydet'}
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Index;
